export default __webpack_public_path__ + "static/media/eric.afdd3296.jpeg";